import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LanguageService, Language } from 'app/core/i18n/language.service';

@Component({
    selector: 'languages',
    templateUrl: './languages.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'languages',
})
export class LanguagesComponent implements OnInit, OnDestroy {
    languages: Language[] = [];
    activeLanguage: Language;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _languageService: LanguageService
    ) {}

    ngOnInit(): void {
        this.languages = this._languageService.getLanguages();
        
        this._languageService.currentLanguage$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((language) => {
                this.activeLanguage = language;
                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    setActiveLanguage(code: string): void {
        this._languageService.setLanguage(code);
    }

    trackByFn(index: number, item: Language): string {
        return item.code;
    }
}
